/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ active: NonNullable<unknown>, waiting: NonNullable<unknown> }} Partner_Home_Customers_NoteInputs */



/**
* | output |
* | --- |
* | "{active} active · {waiting} waiting" |
*
* @param {Partner_Home_Customers_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_customers_note = /** @type {((inputs: Partner_Home_Customers_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_Customers_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.active} aktiv · ${i?.waiting} wartend`)
	return /** @type {LocalizedString} */ (`${i?.active} active · ${i?.waiting} waiting`)
});